// extracted by mini-css-extract-plugin
export default {"innerContainer":"LGy7e5","button":"SoH5kb","smallMargin":"zgiYKw","additionalWhiteSpace":"E90J9S","skipButtonContainer":"N8DkyN","skipButton":"kytAQf","buttonText":"fDYd5k"};